module.exports = __webpack_public_path__ + "static/media/sus1.b039edec.png";